export const SMART_AI_HERO = {
  badge: 'SmartAgents',
  title: 'SmartAgents — AI for marketing,',
  titleEm: 'sales & data',
  sub: 'AI inside your existing tools. Built and maintained, with a human behind anything a customer sees.',
  primaryCta: 'Get In Touch',
  primaryHref: '#get-quote',
  bgSrc: '/images/ai/hero.avif',
  tags: ['Calculators', 'Qualifiers', 'Recommenders', 'Assessments', 'AI Chats', 'Workflows'],
  modelsLabel: 'I work with the models you already use',
  models: [
    { name: 'Claude', src: '/images/claude.png' },
    { name: 'OpenAI', src: '/images/logo-chatgpt.svg' },
    { name: 'Gemini', src: '/images/gemini.svg' },
  ],
} as const

export const SMART_AI_WAVE = {
  title: 'AI agents for every team',
  sub: 'AI-assisted marketing to full agent teams for your business. Start here, or go straight to SimpleAgentic for agentic services.',
  lead: 'I design and implement AI agents, workflows, and automations that plug into your CRM, phone, and site.',
  leadEm: 'More leads converted, around the clock.',
  contact: 'Get In Touch',
  contactHref: '#get-quote',
  simpleAgenticCta: 'Visit SimpleAgentic',
  simpleAgenticHref: 'https://simpleagentic.ai',
} as const

export const SMART_AI_FLIP = {
  capture: {
    n: '01',
    title: 'Capture',
    before: 'Inquiries come in. Half are never answered.',
    after: 'Every lead answered, sorted, and in the right hands.',
    beforeRows: [
      { bar: '70%', pill: 'Routed', dead: false },
      { bar: '52%', pill: 'No reply', dead: true },
      { bar: '64%', pill: 'No reply', dead: true },
      { bar: '44%', pill: 'No reply', dead: true },
    ],
    afterRows: [
      { bar: '70%', pill: 'Sales', dead: false },
      { bar: '52%', pill: 'Service', dead: false },
      { bar: '64%', pill: 'Sales', dead: false },
      { bar: '44%', pill: 'Owner', dead: false },
    ],
  },
  respond: {
    n: '02',
    title: 'Respond',
    before: 'First reply takes hours. The lead has moved on.',
    after: 'First reply in minutes, any hour. More conversations, more closed.',
    beforeTime: '4h 12m',
    beforeNote: 'lead already gone',
    afterTime: '2 min',
    afterNote: 'any hour, any day',
  },
  follow: {
    n: '03',
    title: 'Follow up',
    before: 'One reply, then silence. Old leads left on the table.',
    after: 'Every lead followed up until it converts. Dormant lists turned into revenue.',
    days: ['Day 1', 'Day 3', 'Day 9', 'Day 21'],
  },
} as const
